import { adminClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: typeof window !== "undefined" ? window.location.origin : "http://localhost:3000",
  plugins: [adminClient()],
});

export const { signIn, signOut, useSession } = authClient;

/** Helper type for the user object from Better Auth session */
type SessionUser = NonNullable<Awaited<ReturnType<typeof authClient.getSession>>["data"]>["user"];
